import {createAction, ADMIN_MENU} from './types';

export const toggleMenu = (isOpen) => dispatch => {
    dispatch(createAction(ADMIN_MENU.TOGGLE_MENU, {isOpen}));
}
